// extracted by mini-css-extract-plugin
export default {"goto-withdraw-modal-body":"modal_goto-withdraw-modal-body__sau3K","amount-shadow":"modal_amount-shadow__IGmPB","claim-now-button":"modal_claim-now-button__vi+2f"};